require("./o-search-filters.scss");
let $ = require("jquery");
var csvSeparator = ",,";

//https://gist.github.com/niyazpk/f8ac616f181f6042d1e0
function updateUrlParameter(uri, key, value) {
    // remove the hash part before operating on the uri
    let i = uri.indexOf('#');
    let hash = i === -1 ? '' : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    let separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        uri = uri + separator + key + "=" + value;
    }

    uri = uri.replace(/&?[^&?]+=(?=(?:&|$))/g, ''); // On enlève les paramètres vide
    uri = uri.replace(/\?&/g, '?'); // On remplace le '?$' par '?'
    uri = uri.replace(/\?$/g, ''); // On enlève le ? qui reste seul 

    return uri + hash;  // finally append the hash as well
}

function reloadPage(url) {

    url = updateUrlParameter(url, "page", 1);

    if (url.indexOf('#') <= 0) {
        url += "#filtres-recherche";
    }

    window.location.href = url;
}

function getCheckboxName(key){
    return $(`.m-filter-dropdown[data-parameter-key='${key}']`).find("input[type=checkbox]").first().attr("name");
}

function encodeFilterValue(value) {
    return encodeURIComponent(value).replace(/%20/g, "+");
}

const refreshText = $("#refresh-label").text();

$('[data-controller="filter"]').each(function () {
    var $filter = $('[data-filter="filter"]', this);

    $filter.each(function () {
        var $dropdown = $(this).next('[data-filter="dropdown"]'),
            $allDropdowns = $('[data-filter="dropdown"]'),
            $allFilters = $('[data-filter="filter"]'),
            $this = $(this),
            activeClass = 'o-search-filters__list-item-btn--active';
        $this.on('click', function (e) {
            e.stopPropagation();
            $allDropdowns.not($dropdown).slideUp();
            $dropdown.slideToggle();
            $allFilters.not($this).removeClass(activeClass);
            $this.toggleClass(activeClass);
        });
        $(document).on('click', function (e) {
            if (!$allDropdowns.is(e.target)
                && $allDropdowns.has(e.target).length === 0)
            {
                $allDropdowns.slideUp();
                $allFilters.removeClass(activeClass);
            }
        });
    });

    const searchParams = new URLSearchParams(window.location.search);

    const filterKeys = $(".m-filter-dropdown").get().map(x => $(x).data('parameter-key'));
    const hasFilterKeys = filterKeys.some(x => searchParams.has(x));
    const filterAndSearchKeys = filterKeys.concat(["mots-cles"]);
    const hasSearchKeys = filterAndSearchKeys.some(x => searchParams.has(x));

    if(hasSearchKeys) {
        $(".o-search-filters__active-filters-container").show();
    }

    for (const [key, value] of searchParams.entries()) {
        if(!value || !filterAndSearchKeys.includes(key)) continue;
        if(key != "mots-cles"){
            for (const val of value.split(csvSeparator)) {
                if(!val) continue;
                let checkboxName = getCheckboxName(key);
                const checkbox = $(`label[for='${checkboxName}-${encodeFilterValue(val)}']`);
                appendActivefilter(val, key, checkbox.text());
            } 
        } else {
            appendActivefilter(value, key, value);
        }
        
    }

    function appendActivefilter(filterValue, key, text){
        $('.o-search-filters__active-filters').append(`<button class="o-search-filters__active-filters-btn" data-filter-value="${filterValue}" data-filter-key="${key}">${text}
            <svg  class="o-search-filters__erase-btn-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.9375 3.0625L3.0625 10.9375" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.9375 10.9375L3.0625 3.0625" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg></button>`);
    }

    $('.o-search-filters__active-filters-btn').each(function() {
        const $button = $(this);
        const key = $button.data('filter-key');
        const value = $button.data('filter-value');

        if(key == "mots-cles") {
            $button.off('click');
            $button.on('click', function(e) {
                const input = $(`.m-filter-keyword__input`);
                input.val('');
                $("[data-apply-search-filters]").text(refreshText);
                $(this).remove();
            });

            return;
        }


        let checkboxName = getCheckboxName(key);

        $button.off('click');
        $button.on('click', function(e) {
            const checkbox = $(`input[type=checkbox][name='${checkboxName}'][value='${encodeFilterValue(value)}']`);
            checkbox.trigger("click");
            $(this).remove();
        });

    });


    $('[data-filter-dropdown-option]').each(function() {
        const $checkbox = $(this);
        const $dropdownLabel = $checkbox.closest(".o-search-filters__list-item-dropdown").siblings(".o-search-filters__list-item-btn").children(".o-search-filters__list-item-count");

        var dropDownCheckedCount =  parseInt($dropdownLabel.text());
        if(!dropDownCheckedCount){
            dropDownCheckedCount = 0;
            $dropdownLabel.text(dropDownCheckedCount);
            $dropdownLabel.attr("disabled", true);
        }

        $checkbox.off('click');
        $checkbox.on('click', function(e) {
            var dropDownCheckedCount =  parseInt($dropdownLabel.text());
            if(!dropDownCheckedCount){
                dropDownCheckedCount = 0;
            }

            if ($(this).is(':checked')) {
                $dropdownLabel.text(++dropDownCheckedCount);
                $dropdownLabel.removeAttr("disabled");
                $dropdownLabel.css("display", "inline-block");
            } else {
                $dropdownLabel.text(--dropDownCheckedCount);
                if(dropDownCheckedCount == 0){
                    $dropdownLabel.attr("disabled", true);
                }
            }

            if(hasSearchKeys){
                $("[data-apply-search-filters]").text(refreshText);
            }
        });

        $dropdownLabel.css("display", "inline-block");
        if ($checkbox.is(':checked')) {
            $dropdownLabel.text(++dropDownCheckedCount);
            $dropdownLabel.removeAttr("disabled");
        } 

    });

    /*
     Lancement de la recherche
    */
    $('[data-apply-search-filters]').each(function() {

        const $applyButton = $(this);
        let url = window.location.href;

        $applyButton.off('click.o-search-filters');
        $applyButton.on('click.o-search-filters', function(e) {
            e.preventDefault();
            url = getUrlWithAllDropdownValues(url);

            reloadPage(url);

        });
        
    });
    
    $('.o-search-filters__erase-btn').each(function() {
        const $eraseButton = $(this);
        $eraseButton.off('click.o-erase-btn');
        $eraseButton.on('click.o-erase-btn', function(e) {
            e.preventDefault();
            $('.o-search-filters__active-filters-btn').trigger("click");
        });
        
    });
    
    function getUrlWithAllDropdownValues(baseUrl) {

        let url = baseUrl;

        $('[data-filter-dropdown]').each(function() {
                
            let $dropDown = $(this);
            
            let value = getDropDownQueryStringValue();
            let parameterKey = $dropDown.data('parameter-key');
            url = updateUrlParameter(url, parameterKey, value);

            function getDropDownQueryStringValue() {

                let qsValues = [];
                
                    
                $('[data-filter-dropdown-option]', $dropDown).each(function() {
                    let $option = $(this);

                    if (!$option.is(':checked')) {
                        return;
                    }

                    qsValues.push($option.val());
                });
                

                return qsValues.join(csvSeparator);
            }
        });

        $('[data-filter-keyword]').each(function() {
            let $keywords = $(this);
            let $searchBox = $('[data-search-box]', $keywords);
            let parameterKey = $keywords.data('parameter-key');
            let value = $searchBox.val();
            url = updateUrlParameter(url, parameterKey, value);
        });

        return url;
    }


    let filterKeywordValue = "";
    /*
     Lancement de la recherche : Pour les mot-clés
    */
    $('[data-filter-keyword]').each(function() {
        let $keywords = $(this);
        let $searchBox = $('[data-search-box]', $keywords);
        let $applyButton = $('[data-apply]', $keywords);
        let parameterKey = $keywords.data('parameter-key');
        let url = window.location.href;

        $applyButton.off('click.o-search-filters');
        $applyButton.on('click.o-search-filters', function(e) {
            e.preventDefault();
            url = getUrlWithAllDropdownValues(url);

            reloadPage(url);
        })

        $searchBox.off('keydown.o-search-filters');
        $searchBox.on('keydown.o-search-filters', function(e) {
            filterKeywordValue = $(this).val();
        });
        $searchBox.off('keyup.o-search-filters');
        $searchBox.on('keyup.o-search-filters', function(e) {
            var val = $(this).val();

            if(filterKeywordValue != val ){
                $("[data-apply-search-filters]").text(refreshText);
                filterKeywordValue = val;
            }
        });
        $searchBox.off('keypress.o-search-filters');
        $searchBox.on('keypress.o-search-filters', function(e) {
            $("[data-apply-search-filters]").text(refreshText);

            if (e.which !== 13) {
                return true;
            }

            e.preventDefault();
            url = getUrlWithAllDropdownValues(url);

            reloadPage(url);
        });
    });

});








// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-search-filters/o-search-filters.chunk.js